import { REQUEST_STATUSES } from "../constants";
import { api } from "./instance";
import { getErrorResponse } from "../utils/helper";
import { transformUserData } from "../utils/user-utils";

export class ProfileService {
  static async getProfile() {
    try {
      const resp = await api({
        method: "get",
        url: "/api/v2/profile",
      });

      return {
        err: null,
        resp: transformUserData(resp.data),
        status: REQUEST_STATUSES.SUCCEEDED,
      };
    } catch (err) {
      return {
        err: getErrorResponse(err),
        resp: null,
        status: REQUEST_STATUSES.FAILED,
      };
    }
  }

  static async updateProfile(data) {
    try {
      const resp = await api({
        method: "put",
        url: "/api/v2/profile",
        data,
      });

      return {
        err: null,
        resp: resp.data,
        status: REQUEST_STATUSES.SUCCEEDED,
      };
    } catch (err) {
      return {
        err: getErrorResponse(err),
        resp: null,
        status: REQUEST_STATUSES.FAILED,
      };
    }
  }

  static async deleteProfile() {
    try {
      const resp = await api({
        method: "delete",
        url: "/api/v2/profile",
      });

      return {
        err: null,
        resp: resp.data,
        status: REQUEST_STATUSES.SUCCEEDED,
      };
    } catch (err) {
      return {
        err: getErrorResponse(err),
        resp: null,
        status: REQUEST_STATUSES.FAILED,
      };
    }
  }

  static async getUserById(userId) {
    try {
      const resp = await api({
        method: "get",
        url: `/api/v2/users/${userId}`,
      });

      return {
        err: null,
        resp: transformUserData(resp.data),
        status: REQUEST_STATUSES.SUCCEEDED,
      };
    } catch (err) {
      return {
        err: getErrorResponse(err),
        resp: null,
        status: REQUEST_STATUSES.FAILED,
      };
    }
  }
}
